import { ParsedUrlQuery } from 'querystring';

export const getSortQuery = (query: ParsedUrlQuery): ParsedUrlQuery =>
  query?.sort === 'deals-first' ? { sort: query.sort } : undefined;
